<!-- section template -->
<template>
  <div :class="$style.prepaidSectionItemInfoBox">
    <ul :class="[$style.detailList, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]">
      <li v-if="!!orderList[0]" class="detailList__item">
        <div class="row">
          <div class="col-md-3">
            <div class="detailList__title"> 訂單明細 </div>
          </div>
          <div class="col-md-9">
            <BaseList :data-list="orderList" type="order" />
          </div>
        </div>
      </li>
      <li v-if="!!orderInfoList[0]" class="detailList__item">
        <div class="row">
          <div class="col-md-3">
            <div class="detailList__title"> 訂單資訊 </div>
          </div>
          <div class="col-md-9">
            <BaseList :data-list="orderInfoList" type="info" />
          </div>
        </div>
      </li>
      <li v-if="(orderItem.paymentMethod === 'Vacc' && !!vaccInfoList[0]) || (orderItem.paymentMethod === 'Atm' && !!atmInfoList[0])" class="detailList__item">
        <div class="row">
          <div class="col-md-3">
            <div class="detailList__title"> 匯款資訊 </div>
          </div>
          <div class="col-md-9">
            <BaseList v-if="orderItem.paymentMethod === 'Vacc' && !!vaccInfoList[0]" :data-list="vaccInfoList" type="info" />
            <BaseList v-if="orderItem.paymentMethod === 'Atm' && !!atmInfoList[0]" :data-list="atmInfoList" type="info" />
          </div>
        </div>
      </li>
      <!-- 發票 -->
      <li v-if="orderItem.invoice.InvoiceNumber != null" class="detailList__item">
        <div class="row">
          <div class="col-md-3">
            <div class="detailList__title"> 發票資訊 </div>
          </div>
          <div class="col-md-9">
            <div class="invoice-detail__item">
              <p>發票日期：{{ orderItem.invoice.CreateTime }}</p>
            </div>
            <div class="invoice-detail__item">
              <p>發票號碼：{{ orderItem.invoice.InvoiceNumber }}</p>
            </div>
            <div class="invoice-detail__item">
              <p>隨機碼：{{ orderItem.invoice.RandomNum }}</p>
            </div>
            <div class="invoice-detail__item">
              <p>發票形式：{{ taxTypeMap[orderItem.invoice.taxType] }}</p>
            </div>
            <div v-if="orderItem.invoice.taxType === 'B2C'" class="invoice-detail__item">
              <p style="margin-bottom: 0">載具類型：{{ carrierTypeMap(orderItem.invoice.CarrierType) }}</p>
            </div>
          </div>
        </div>
      </li>
    </ul>

    <OrderPaymentButton :order-item="orderItem" type="prepaid" button-class="mt-5" />
  </div>
</template>

<script>
import formatCurrency from '@utils/format-currency'
import { merchantComputed } from '@store/helpers'
import { orderAtmInfoList, orderInfoList, orderIsCanPay, orderIsOffline, orderVaccInfoList } from '@utils/ipetbooking-order'
import { conditionList } from '@utils/is-condition'

export default {
  components: {
    OrderPaymentButton: () => import('@components/Order/OrderPaymentButton'),
  },
  props: {
    orderItem: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      taxTypeMap: {
        B2C: '個人',
        B2B: '公司',
        DONATE: '捐贈發票',
      },
    }
  },
  computed: {
    ...merchantComputed,
    isOffline() {
      return orderIsOffline({
        order: this.orderItem,
        ordertype: 'order',
        type: 'prepaid',
      })
    },
    orderList() {
      const paramsList = (item) => {
        const defaultItem = {
          text: item.total < 0 ? `- NT$ ${formatCurrency(Math.abs(item.total))}` : `NT$ ${formatCurrency(item.total)}`,
          class: item.total < 0 ? 'text-danger' : '',
          textClass: 'font-number',
        }
        switch (item.type) {
          case '+':
            return {
              ...defaultItem,
              title: `加價`,
              shortTitle: `加價`,
            }
          case '-':
            return {
              ...defaultItem,
              title: `減價`,
              shortTitle: `減價`,
            }
          case 'deposit':
            return {
              ...defaultItem,
              title: '儲值金付款',
              shortTitle: '儲值金付款',
            }
          case '%':
            return {
              ...defaultItem,
              title: `折扣(${item.description}%)`,
              shortTitle: `折扣(${item.description}%)`,
            }
          default:
            return false
        }
      }
      const orderBillingParamsList = () => {
        return this.orderItem.params.map((item) => {
          return paramsList(item)
        })
      }
      return conditionList([
        {
          title: `${this.orderItem.prepaid.title} x1
            <br>
            <span class="fs-2sm text-gray-2">
              <i class="fontello ${this.$globalIsDingBeauty ? 'fontello-db-lipstick' : 'fontello-paw'} fa-fw mr-2 text-gray-3"></i></i><span>${this.orderItem.prepaid.categoryTitle} | ${
            this.orderItem.prepaid.sizeTitle
          }</span>
            </span>
          `,
          text: `${
            this.orderItem.params[0].levelDiscount > 0
              ? `<span class="text-gray-2">
                會員價：NT$ ${formatCurrency(this.orderItem.params[0].total)}
              </span>
              <br>
              <span class="font-number text-decoration-line-through fs-2sm text-gray-2">售價：NT$ ${formatCurrency(this.orderItem.params[0].price)}</span>
              `
              : this.orderItem.prepaid.price
          }
            `,
          textClass: 'font-number',
        },
        // {
        //   title: `折扣${this.orderItem.discountValue}${this.orderItem.discountType === '%' ? '%' : ''}`,
        //   text: `-NT$ ${formatCurrency(this.orderItem.discountAmount)}`,
        //   class: 'text-danger',
        //   textClass: 'font-number',
        //   condition: () => {
        //     return !!this.orderItem.discountAmount && !!this.orderItem.discountType && !!this.orderItem.discountValue
        //   },
        // },
        ...orderBillingParamsList(),
        {
          type: 'hr',
        },
        {
          title: '總計',
          text: `<span>NT$ ${formatCurrency(this.orderItem.price)}</span>`,
          textClass: 'font-number',
        },
      ])
    },
    orderInfoList() {
      return orderInfoList({ ...this.orderItem })
    },
    vaccInfoList() {
      return orderVaccInfoList({ ...this.orderItem, unpaid: this.orderItem.price })
    },
    atmInfoList() {
      return orderAtmInfoList({ ...this.orderItem, unpaid: this.orderItem.price })
    },
  },
  methods: {
    orderIsCanPay,

    carrierTypeMap(key) {
      const map = {
        0: '手機條碼',
        1: '自然人憑證條碼',
        2: 'ezPay 電子發票載具',
      }

      if (key == null) return '無（寄送電子發票至客戶 email）'
      else return map[key]
    },
  },
}
</script>

<!-- section style -->
<style lang="scss" module>
.prepaidSectionItemInfoBox {
  :global {
    .prepaidSectionItemInfoBox {
      @include unstyled;
    }

    .invoice-detail__item {
      display: flex;
      justify-content: space-between;

      p {
        margin-bottom: 12px;
        color: #687580;
      }
    }
  }
}

.detailList {
  @include list-unstyled;

  margin: 0 0 2rem;

  :global {
    .detailList {
      &__item {
        &:not(:last-child) {
          padding-bottom: 2rem;
          border-bottom: 1px solid $color-line;
        }

        &:not(:first-child) {
          padding-top: 2rem;
        }

        &.isTitle {
          padding: 1.5rem;
          background: rgba($color-secondary, 0.1);
          border-bottom: unset;
        }
      }

      &__title {
        @extend %FontSerifWeightJtails;

        @include max-md {
          margin-bottom: 1rem;
          // color: $color-blue-dark;
        }
      }
    }
  }
  &.isStyleDingBeauty {
    :global {
      .detailList {
        &__title {
          font-family: unset;
          font-weight: 400;
          color: $color-secondary;
        }
      }
    }
  }
}
</style>
